// MOD-08 — SEO anahtar kelime girişi. BE `Keywords` alanı virgül-ayrık tek bir
// string (max 500 karakter) olarak saklanır; burada AntD `Select mode="tags"`
// ile silinebilir çipler olarak sunulur. String <-> dizi dönüşümü ayrı
// `keywords.ts` yardımcılarıyla yapılır (birim test edilebilir).

import { Select } from 'antd';
import { joinKeywords, parseKeywords } from './keywords';

export interface KeywordsInputProps {
  value?: string | null;
  onChange?: (value: string | null) => void;
  placeholder?: string;
  /** Çip sayısı üst sınırı — BE 500-karakter limitini de dolaylı korur. */
  maxKeywords?: number;
  disabled?: boolean;
  id?: string;
}

const DEFAULT_MAX_KEYWORDS = 25;

export function KeywordsInput({
  value,
  onChange,
  placeholder,
  maxKeywords = DEFAULT_MAX_KEYWORDS,
  disabled,
  id,
}: KeywordsInputProps) {
  const tokens = parseKeywords(value);
  return (
    <Select
      id={id}
      mode="tags"
      value={tokens}
      onChange={(next) => onChange?.(joinKeywords(next.slice(0, maxKeywords)))}
      tokenSeparators={[',']}
      open={false}
      suffixIcon={null}
      placeholder={placeholder}
      disabled={disabled}
      style={{ width: '100%' }}
    />
  );
}

export default KeywordsInput;
